// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3233":"4e5da1ec","3804":"c28c0804","4650":"b42056f4","6866":"c28c0804"}[chunkId] + ".chunk.css";
};